import { createContext } from "react";

import type { Impulse } from "~/tools/impulse";

export interface SouthPaneState {
	isOpen: Impulse<boolean>;
}

export const SouthPaneContext = createContext<null | SouthPaneState>(null);
